import { ActivityIndicator, Platform } from "@-/com.npmjs.react-native";
import { AppLayout } from "@-/dev.improve.haniverse.routes.nav.app";
import { SafeAreaView as SafeAreaViewFromSafeAreaContext } from "@-/com.npmjs.react-native-safe-area-context";
import { withUniwind } from "@-/com.npmjs.uniwind";

const SafeAreaView = withUniwind(SafeAreaViewFromSafeAreaContext);

/**
 * Expo Router inherits this into EVERY descendant route's internal Suspense boundary.
 * Keep it destination-neutral: a Learn fallback here renders Welcome Back inside Browse
 * when a leaf suspends, even when Browse wraps its Slot in its own Suspense boundary.
 * Destination-specific fallbacks belong to that destination's layout export only.
 */
export function SuspenseFallback() {
  if (Platform.OS === "web") {
    return null;
  }
  return (
    <SafeAreaView
      accessibilityLabel="Loading page"
      className="flex-1 items-center justify-center bg-background"
      testID="app-route-loading"
    >
      <ActivityIndicator />
    </SafeAreaView>
  );
}

export const unstable_settings = {
  // Native anchors the app group to Learn so a cold launch lands on the study tab.
  //
  // WEB (SSR) takes no anchor: React Navigation seeds a stack from its initial route, so anchoring
  // here made the SERVER render the Learn tab for every url — `/browse/morpheme/<g>` produced no
  // browse content for crawlers. On web the requested url IS the intent, so the group renders
  // whichever child the url selects.
  anchor: Platform.OS === "web" ? undefined : "learn",
};

export default function AppLayoutRoute() {
  return <AppLayout />;
}
